import React, {PureComponent} from 'react';

import SummaryHeader from 'components/summary/SummaryHeader'
import SummaryBody from 'components/summary/SummaryBody'
import StickerMixed from 'components/stickers/StickerMixed'
import StickerInsurance from 'components/stickers/StickerInsurance'
import StickerWorkshop from 'components/stickers/StickerWorkshop'

import css from './TabDashboard.module.css'

const stickerIdInsurance = "-Kr_2jirEyJFVFfShggD";
const stickerIdMixed = "-KwQj-KngsfboF9KCwJY";
const stickerIdWorkshop = "-KwVFa336q1Rytl5RlFA";

class TabDashboard extends PureComponent {
	render() {
		const {stickerId, globalLogsAvailable, stats/*, onNextTab*/} = this.props;

		return (
			<div className={css.container}>
				<div className={css.content}>
					<div className={css.header}>
						{globalLogsAvailable && stats && <SummaryHeader stats={stats}/>}
					</div>
					<div className={css.body}>
						{stickerId === stickerIdMixed && <StickerMixed/>}
						{stickerId === stickerIdInsurance && <StickerInsurance/>}
						{stickerId === stickerIdWorkshop && <StickerWorkshop/>}
						{!stickerId && globalLogsAvailable && <SummaryBody/>}
					</div>

				</div>
			</div>
		);
	}
}

export default TabDashboard;



// WEBPACK FOOTER //
// ./src/components/tabs/TabDashboard.jsx